export default __webpack_public_path__ + "assets/images/3f928cf4535ced989f3268cdbfd1b466.png";